<template>
    <div>
        <div v-html="text">
        </div>
    </div>

</template>

<script>
import _ from 'lodash';

    export default {
        name: "c_text",
        props: {
            format: {
                default: "small"
            }
        },
        data: function () {
            return {
                text: ""
            };
		},
		methods: {
            async load(data)
            {
                this.data = data;

                if (this.format == 'small')
                    this.text = this.data.text_small ? this.data.text_small.replace(/\n/g, "<br />") : "";
                else
                    this.text = this.data.text_big ? this.data.text_big.replace(/\n/g, "<br />") : "";

                var compiled = _.template(this.text);
                this.text = compiled({  });
            },
            async load_data()
            {

            }
		},
		mounted: function () {

		},
    }


</script>